import type { Texts } from '../useTexts'

export const createValidateName = (texts: Texts, name: string) => {
  const nameMaxLengthError = {
    id: 'nameMaxLengthError',
    message: texts.errors.maxLength(30),
    field: 'name',
    priority: 15,
  }

  const nameRequiredError = {
    id: 'nameRequiredError',
    message: texts.errors.required('user name'),
    field: 'name',
    priority: 10,
  }

  const requiredError = name.length === 0
  const maxLengthError = name.length > 30

  return {
    [nameRequiredError.id]: requiredError ? nameRequiredError : undefined,
    [nameMaxLengthError.id]: maxLengthError ? nameMaxLengthError : undefined,
  }
}
